module.exports = __webpack_public_path__ + "img/solution_img_en.539fc30c.png";